import React, { useState } from 'react';
import { useChatState, useChatDispatch } from '../context';
import { TextInput, Button, Box, Modal, useMantineTheme } from '@mantine/core';
import { sendUserMessage } from '../../../../graphql/mutations';
import { generateClient } from 'aws-amplify/api';
import { Amplify } from 'aws-amplify';
import knowledgeBase from '../../../../../src/assets/icons/Knowledge base (1).gif';

export const ChatMsgSent = () => {
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const { selectedChat, userId } = useChatState();
  const [modalOpened, setModalOpened] = useState(false);
  const theme = useMantineTheme(); // Get the theme object

  const dispatch = useChatDispatch();

  function capitalizeFirstLetter(string) {
    return string?.charAt(0)?.toUpperCase() + string?.slice(1);
  }

  const capitalizedUserId = capitalizeFirstLetter(userId);
  const [sending, setSending] = useState(false);
  const client = generateClient();

  Amplify.configure({
    API: {
      GraphQL: {
        endpoint: process.env.REACT_APP_API_URI,
        region: process.env.REACT_APP_AWS_REGION,
        defaultAuthMode: 'apiKey',
        apiKey: process.env.REACT_APP_APPSYNC_API_KEY
      }
    }
  });

  const handleSendMessage = async () => {
    if (!message.trim()) return;

    setSending(true);
    setModalOpened(true); // Open modal when processing starts

    const input = {
      newConversation: !selectedChat?.id,
      conversationId: selectedChat?.id || undefined,
      userId: capitalizedUserId,
      instructions: '{ "randomize_factor": "high" }',
      content: JSON.stringify({ query: message }),
      timestamp: new Date().toISOString()
    };
    console.log(input);
    try {
      const data = await client.graphql({
        query: sendUserMessage,
        variables: { input }
      });
      console.log(data);
      if (data?.data?.sendUserMessage) {
        if (selectedChat?.id === undefined) {
          dispatch({ type: 'SENT_NEW_MESSAGE', payload: true });
        }
      }
    } catch (error) {
      console.error('Error sending message:', error);
    } finally {
      setSending(false);
      setModalOpened(false); // Close modal when done
      setMessage('');
    }
  };

  return (
    <>
      <Modal
        opened={modalOpened}
        onClose={() => setModalOpened(false)}
        withCloseButton={false}
        centered
        size="auto"
        overlayProps={{ blur: 2 }}
      >
        <div style={{ textAlign: 'center', padding: '20px' }}>
          <img
            src={knowledgeBase}
            alt="Processing request"
            style={{ width: '200px', height: '200px' }}
          />
          <p style={{ marginTop: '10px' }}>Searching knowledge base...</p>
        </div>
      </Modal>

      <Box style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        <TextInput
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          placeholder="Type a message"
          style={{ flex: 1 }}
          onKeyDown={(e) => {
            if (e.key === 'Enter' && !e.shiftKey) {
              e.preventDefault();
              handleSendMessage();
            }
          }}
        />
        <Button
          onClick={handleSendMessage}
          disabled={sending}
          loading={sending}
          style={{
            flexShrink: 0,
            padding: '0 1rem',
            backgroundColor: `${theme.colors.primary[0]}`
          }}
        >
          Send
        </Button>
      </Box>
    </>
  );
};
